import { render } from "./ReturnDetails.vue?vue&type=template&id=35ae28b4&scoped=true&ts=true"
import script from "./ReturnDetails.vue?vue&type=script&lang=ts"
export * from "./ReturnDetails.vue?vue&type=script&lang=ts"

import "./ReturnDetails.vue?vue&type=style&index=0&id=35ae28b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae28b4"]])

export default __exports__